/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_RemoveInputs */

const en_us2_plan_edit_remove = /** @type {(inputs: Plan_Edit_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from workout`)
};

const pt_br2_plan_edit_remove = /** @type {(inputs: Plan_Edit_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover do treino`)
};

const es_419_plan_edit_remove = /** @type {(inputs: Plan_Edit_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar del entrenamiento`)
};

const pt_pt2_plan_edit_remove = /** @type {(inputs: Plan_Edit_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover do treino`)
};

const fr_fr2_plan_edit_remove = /** @type {(inputs: Plan_Edit_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer de la séance`)
};

const de_de2_plan_edit_remove = /** @type {(inputs: Plan_Edit_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus dem Training entfernen`)
};

const it_it2_plan_edit_remove = /** @type {(inputs: Plan_Edit_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi dall'allenamento`)
};

/**
* | output |
* | --- |
* | "Remove from workout" |
*
* @param {Plan_Edit_RemoveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_remove = /** @type {((inputs?: Plan_Edit_RemoveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_RemoveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_remove(inputs)
	if (locale === "es-419") return es_419_plan_edit_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_remove(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_remove(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_remove(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_remove(inputs)
	return en_us2_plan_edit_remove(inputs)
});
export { plan_edit_remove as "plan-edit.remove" }